import(/* webpackMode: "eager", webpackExports: ["InfoCard"] */ "/root/edocai/edocai/app/[lang]/components/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/edocai/edocai/app/[lang]/components/Preview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/edocai/edocai/app/[lang]/components/ServicesSection.tsx");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/header_il-progetto.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/posts/discente.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/posts/kol.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/posts/sponsor.jpg");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/team/davide.png");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/team/loredana.png");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/team/vanessa.png");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/assets/edocai/images/team/yolanda.png");
;
import(/* webpackMode: "eager" */ "/root/edocai/edocai/node_modules/next/dist/client/image-component.js");
